import React, { Component } from "react";

import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon"

import MDInput from "components/MDInput";
import MDBox from "components/MDBox";
import MDAvatar from "components/MDAvatar";
import MDButton from "components/MDButton";

import MDTypography from "components/MDTypography";
import styles from "./index.module.css";

import { PATH, UPLOAD_PATH } from "../../constant";
import 'dayjs/locale/it';

import * as ajax from "helpers/ajax";
import dayjs from 'dayjs';
import MapContainer from "components/GoogleMap";


export class CommessaMaps extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data:[]
        };
        this._isMounted = false;
    }

    componentDidMount = () => {
        this._isMounted = true;
        ajax.ajaxGetStrapi("commessas?populate=commessa_madre&filters[stato][$ne]=finito", this.loadCallback)
    }

    componentWillUnmount = () => {
        this._isMounted = false;
    }

    loadCallback = (response) => {
        // Verifica se il componente è ancora montato prima di aggiornare lo state
        if (this._isMounted && response && response.data) {
            this.setState({data:response.data})
        }
    }

    markers = () => {
        let markers = []

        this.state.data.map((el) => {

            if (el.latitudine_indirizzo && el.longitudine_indirizzo) {
                markers.push({ position: { lat: el.latitudine_indirizzo, lng: el.longitudine_indirizzo } })
                if (el.commessa_madre) {markers[markers.length - 1].mini = true;}
            }

            if (el.latitudine_Indirizzo_2 && el.longitudine_Indirizzo_2) {
                markers.push({ position: { lat: el.latitudine_Indirizzo_2, lng: el.longitudine_Indirizzo_2 } })
                if (el.commessa_madre) { markers[markers.length - 1].mini = true; }
            }

            if (el.latitudine_Indirizzo_3 && el.longitudine_Indirizzo_3) {
                markers.push({ position: { lat: el.latitudine_Indirizzo_3, lng: el.longitudine_Indirizzo_3 } })
                if (el.commessa_madre) { markers[markers.length - 1].mini = true; }
            }
        })

        return markers;
    }

    render() {
        return (
            <>
                <MDTypography variant={"h5"} textTransform={"uppercase"} mb={2} >Mappa Commesse</MDTypography>
                <MapContainer
                    key={Date.now()}
                    center={{
                        lat: 41.2925,
                        lng: 12.5736
                    }}
                    marker={this.markers()}
                    zoom={5}
                    height={420}
                />

            </>
        )

    }
}

export default CommessaMaps;


CommessaMaps.defaultProps = {

}
